import React, { useEffect, useState } from 'react';
import { Popup } from './Popup';
import './Donateform.css';
import { useNavigate } from 'react-router-dom';
import MasterCardImage from '../../assets/PNG/mastercard.png'
import VisaCardImage from '../../assets/PNG/visa.png'
import AmericanExpressCardImage from '../../assets/PNG/american-express.png'
import DiscoverCardImage from '../../assets/PNG/discover-card-logo.jpg'
import AuthorizeNetImage from '../../assets/PNG/authorize-net-seeklogo.png'
import ENV from '../../constants/env-constants';
import { getUserDetails } from '../../utils/api';

function Donateform({ userId }) {
  const [selectedFrequency, setSelectedFrequency] = useState('monthly');
  const [selectedAmount, setSelectedAmount] = useState('$25');
  const [customAmount, setCustomAmount] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiryMonth, setExpiryMonth] = useState('');
  const [expiryYear, setExpiryYear] = useState('');
  const [cvv, setCvv] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [companyOrOrganizationName, setCompanyOrOrganizationName] = useState('');
  const [countryName, setCountryName] = useState('');
  const [userType, setUserType] = useState('');
  const [zipcode, setZipCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  // popup
  const [showPopup, setShowPopup] = useState(false);
  const [transactionMessage, setTransactionMessage] = useState('');

  useEffect(()=>{
    async function storeDetails() {
      const data = await getUserDetails(userId);
      setFirstName(data.firstName);
      setLastName(data.lastName);
      setCompanyOrOrganizationName(data.companyOrOrganization);
      setCountryName(data.country);
      setEmail(data.email);
      setZipCode(data.zipcode)
      setUserType(data.userType)
    }
    if (userId) storeDetails()
  }, []);
  const validateForm = () => {
    // Ensure that either a preset amount is selected or a custom amount is entered.
    const amount = selectedAmount === 'custom' ? customAmount : selectedAmount;
    if (!selectedFrequency || (!selectedAmount && !customAmount) || !cardNumber || !expiryMonth || !expiryYear || !cvv) {
      setErrorMessage('Please fill all fields.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleFrequencySelect = (frequency) => {
    setSelectedFrequency(frequency);
  };

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    // If a preset amount is selected, clear the custom amount.
    if (amount !== 'custom') {
      setCustomAmount('');
    }
  };


  const handleCustomAmountChange = (event) => {
    const value = event.target.value;
    // Directly set custom amount from the event, and ensure 'custom' is selected.
    setCustomAmount(value);
    setSelectedAmount('custom');
  };


  const handleNumericChange = (event, setter) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) { // Allows only numbers or an empty string
      setter(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return; // Prevent form submission if validation fails
    }
    
    const parsedAmount = selectedAmount === 'custom' ? parseFloat(customAmount) : parseFloat(selectedAmount.replace('$', ''));
    
    const payload = {
      userid: userId,
      creditCard: cardNumber,
      cardCVV: cvv,
      cardExpiryDate: `${expiryYear}-${expiryMonth}`,
      amount: isNaN(parsedAmount) ? 0 : parsedAmount,
      currencyCode: "USD",
      frequency: selectedFrequency,
      firstName,
      lastName,
      email,
      companyOrOrganizationName,
      countryName,
      zipcode,
      userType
    };

    console.log(payload)

    setShowPopup(true); // Show loading indicator (considered as part of popup for simplicity)
    setTransactionMessage('Processing...');

  // Perform the API call
  fetch(`${ENV.API_URL}/api/donate/makePayment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  .then(response => response.json())
  .then(data => {
    // Check if the transaction was successful or failed based on API response
    if (data.success) {
    navigate('/site/donate/confirm');
    } else {
      setTransactionMessage(data.message || 'Transaction Failed'); // Show API provided message or a default one
    }
  })
  .catch(error => {
    console.error('Error:', error);
    setTransactionMessage('An error occurred. Please try again.'); // Handle any fetch errors
  });
  };


  // Utility function to dynamically apply selection styles
  const isSelected = (value) => {
    return selectedFrequency === value || selectedAmount === value ? 'selected' : '';
  };

  return (
    <div id="right-side"  style={{display:'flex', justifyContent:'center', alignItems:'center'}} className="col-lg-6">
      <form id="payment-form" onSubmit={handleSubmit}>
        <h1 style={{ color: 'var(--dark)' }}>Help us make a difference!</h1>
        {/* Donation Frequency */}
        <div className="frequency-buttons">
          <div className={`box ${isSelected('one-time')}`} onClick={() => handleFrequencySelect('one-time')}>One Time</div>
          <div className={`box ${isSelected('monthly')}`} onClick={() => handleFrequencySelect('monthly')}>Monthly</div>
        </div>
        {/* Donation Amount */}
        <h3 style={{ marginTop: '10px' }}>Select Donation Amount</h3>
        <div className="donation-amount">
          <div className={`block ${isSelected('$1')}`} onClick={() => handleAmountSelect('$1')}>$1</div>
          <div className={`block ${isSelected('$25')}`} onClick={() => handleAmountSelect('$25')}>$25</div>
          <div className={`block ${isSelected('$100')}`} onClick={() => handleAmountSelect('$100')}>$100</div>
          <div className={`block ${isSelected('$500')}`} onClick={() => handleAmountSelect('$500')}>$500</div>
          <input type="text" className={`block ${isSelected('custom')}`} placeholder="Custom Amount" value={customAmount} inputMode="numeric" pattern="\d*" onChange={(e) => {handleNumericChange(e, setCustomAmount);handleCustomAmountChange(e)}} />
        </div>
        {/* Payment Options */}
        <h2 style={{ marginTop: '15px' }}>Payment Options</h2>
        <div id="payment-options">
          <div style={{ marginBottom: '3%' }} className="payment-option">
            {/* <img src="/img/img/card1.png" width={80} height={30} alt="" /> */}
            <img src={VisaCardImage} width={70} alt="visa-card-log" />
            <img src={MasterCardImage} style={{marginRight: "0.5rem"}} width={50} alt="master-card-logo" />
            <img src={AuthorizeNetImage} style={{marginRight: "0.5rem"}} width={70} alt="authorize-net-logo" />
            <img src={AmericanExpressCardImage} width={45} alt="american-express-logo" />
            <img src={DiscoverCardImage} width={80} alt="discover-card-logo" />
          </div>
        </div>
        <div style={{display: "flex", columnGap: '1rem'}}>
          <input type="text" placeholder='First Name' className="credit-card-inputs" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
          <input type="text" placeholder='Last Name' className="credit-card-inputs" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        </div>
        <div>
          <input type="text" placeholder='Email Id' className="credit-card-inputs" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <input type="text" placeholder='Company or Organization (if applicable)' className="credit-card-inputs" value={companyOrOrganizationName} onChange={(e) => setCompanyOrOrganizationName(e.target.value)} />
        </div>
        <div style={{display: "flex", columnGap: '1rem'}}>
                <select value={countryName} onChange={(e) => setCountryName(e.target.value)} className="credit-card-inputs" aria-label="Country">
                  <option value="" disabled>-- Please Choose The Country --</option>
                  <option>United States</option>
                  <option>Australia</option>
                  <option>Canada</option>
                  <option>New Zealand</option>
                  <option>South Africa</option>
                  <option>United Kingdom</option>
                </select>
        </div>
        <div style={{display: "flex", columnGap: '1rem'}}>
                <select value={userType} onChange={(e) => setUserType(e.target.value)} className="credit-card-inputs" aria-label="User type" required>
                  <option value="" disabled>-- Please Choose The Category --</option>
                  <option value="individual">Individuals</option>
                  <option value="corporate">Corporate Partners</option>
                  <option value="educational">Educational Institutions</option>
                  <option value="foundations">Foundations and Trusts</option>
                </select>
        </div>
        <div style={{display: "flex", columnGap: '1rem'}}>
        <input type="text" placeholder='Zipcode' className="credit-card-inputs" value={zipcode} onChange={(e) => setZipCode(e.target.value)} required />
        </div>
        <input type="text" placeholder="Debit or Credit Card Number" className="credit-card-inputs" value={cardNumber} inputMode="numeric" pattern="\d*" onChange={(e) => handleNumericChange(e, setCardNumber)} />
        <div className="expiration-date">
          <select id="expiry-month" value={expiryMonth} onChange={(e) => setExpiryMonth(e.target.value)}>
            <option value="" disabled>Month</option>
            {/* Months */}
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')} - {new Date(0, i).toLocaleString('en', { month: 'long' })}</option>
            ))}
          </select>
          <select id="expiry-year" value={expiryYear} onChange={(e) => setExpiryYear(e.target.value)}>
            <option value="" disabled>Year</option>
            {/* Years */}
            {[...Array(10)].map((_, i) => (
              <option key={i} value={new Date().getFullYear() + i}>{new Date().getFullYear() + i}</option>
            ))}
          </select>
          <input type="text" placeholder="CVV" inputMode="numeric" pattern="\d*" onChange={(e) => handleNumericChange(e, setCvv)} className="cvv-input" style={{ marginTop: '-1px', height: '40px' }} value={cvv} />
        </div>
        <button type="submit" className="submit-button btn btn-primary btn-lg">Submit Donation</button>
        {/* Error Message Display */}
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </form>
      {/* popup */}
      {showPopup && <Popup message={transactionMessage} onClose={() => setShowPopup(false)} />}
    </div>
  );
}

export default Donateform;
